import { MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledOpeningOfArticle = styled.div`
  position: relative;
  .premium-badge {
    margin-bottom: 12px;
    ${MediaQueries.mbDown} {
      margin-bottom: 8px;
    }
  }
  .article-author {
    margin-bottom: 1.5em;
    ${MediaQueries.mbUp} {
      display: none;
    }
  }
  .article-header {
    margin-bottom: 1em;
    color: ${(props: ThemeProps) => props.theme.colors.gray800};
  }
`

export const StyledJumpingLink = styled.ul`
  margin-bottom: 16px;
  a {
    text-decoration: none;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: -0.2px;
    color: #2661ad;
  }
  > li {
    margin-bottom: 8px;
  }

  > li:before {
    content: url('/svg/dot.svg');
    font-size: 1em;
    vertical-align: middle;
    margin-right: 8px;
  }
`
